export default __webpack_public_path__ + "static/media/logo-staynfun_2.b1256962.svg";